import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ROOT_URL } from "../../api/ApiConfig";

function getAuthToken(getState) {
  const { loginToken, loginTokenCoUser } = getState();
  return loginToken?.response?.token || loginTokenCoUser?.response?.token;
}

export const getAllCanned = createAsyncThunk(
  "tag/canned-message",
  async ({ id, groupId }, { getState, rejectWithValue }) => {
    const authToken = getAuthToken(getState);
    try {
      const params = groupId ? `?group_id=${encodeURIComponent(groupId)}` : "";
      const response = await fetch(`${ROOT_URL}/tag/canned-message/${id}${params}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const GetAllCanned = createSlice({
  name: "GetAllCanned",
  initialState,
  reducers: {},
  extraReducers: {
    [getAllCanned.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [getAllCanned.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [getAllCanned.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default GetAllCanned.reducer;
